import React, { useState, useEffect } from "react";
import Report from "../report/report";
import { StandartButton } from "commons/form-controls";
import { ReactComponent as TopicSettingsIcon } from 'assets/icons/topic-settings.svg';
import s from "./template-list.module.scss"

const TemplateList = (props) => {

    const [selectedReport, setSelectedReport] = useState(props.selectedReportTemplate);

    useEffect(() => {
        setSelectedReport(props.selectedReportTemplate);
    }, [props]);

    const setSelectedReportId = (reportId) => {
        setSelectedReport(reportId)
        props.setSelectedReportTemplate(reportId)
    }



    const copyTemplate = (template, copyTitle) => {
        props.modalShowToggle("CopyReportTemplate", true, null,  props.getValue("CREATE_DUPLICATE"), {currentPage: props.currentPage, showedItemsCount: props.showedItemsCount, template: template});
        /*let n =  template.name+" "+copyTitle;
        let f = -1;
        if(props.reportTemplates && props.reportTemplates.content){
            f = props.reportTemplates.content.findIndex(k => k.name === n)
        }
        if(f == -1){
            props.copyTemplate(template, copyTitle, props.currentPage, props.showedItemsCount);
        }
        else{
            const regex = new RegExp("^" + template.name, "i");
            const result = props.reportTemplates.content.filter(k => regex.test(k.name));
            const findT = result && result.length ? result.findIndex(k => k.name == template.name + " "+ copyTitle + " (1)") : -1;
            if(result.length && findT != -1){
                const max = Math.max(
                    ...result
                      .map(str => (str.name.match(/\((\d+)\)$/)?.[1]))
                      .filter(Boolean)
                      .map(Number)
                  );
                props.copyTemplate(template, copyTitle+" ("+(max+1)+")", props.currentPage, props.showedItemsCount);
            }
            else{
                props.copyTemplate(template, copyTitle+" (1)", props.currentPage, props.showedItemsCount);
            }
        }*/
    }

    const getTopicName = (topicUUID) => {
        return topicUUID;
    }

    const showCreateTemplateModal = () => {
        props.modalShowToggle("CreateReportTemplate", true, null,  props.getValue("CREATE_REPORT_TEMPLATE"), {currentPage: props.currentPage, showedItemsCount: props.showedItemsCount});
    }

    const reports = props.reportTemplates.content.map(k => <Report 
                                                                    setIsReadOnly={props.setIsReadOnly} 
                                                                    isReadOnly={props.isReadOnly} 
                                                                    key={k.id} 
                                                                    selectedReport={selectedReport} 
                                                                    controlButtons={props.controlButtons} 
                                                                    getTopicName={getTopicName} 
                                                                    item={k} 
                                                                    getValue={props.getValue} 
                                                                    setSelectedReportId={setSelectedReportId}
                                                                    copyTemplate={copyTemplate}
                                                                    deleteReportTemplate={props.deleteReportTemplate}/>)

    return (
        <div className={s.TemplateList}>
            <div className={s.CreateTemplateButton}>
                <span>{props.getValue('LIST_OF_TEMPLATES')}</span>
                <StandartButton title={props.getValue('CREATE_TEMPLATE')} icon={TopicSettingsIcon} stroke={'white'} fill={'white'} callback={showCreateTemplateModal}/>
            </div>
            { reports }
        </div>
    )
}

export default TemplateList;